import React from "react";
import { Link } from "gatsby";
import { scale } from "../utils/typography";
import styled from "styled-components";
import NavigationSimple from "./navigation--simple";
import FooterSimple from "./footer-simple";
import "normalize.css";
import "../styles/global.css";

const LayoutSimple = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`;
  let header;

  const LayoutContainer = styled.div`
    /* margin-left: 200px; */
    padding: 2rem;
    /* max-width: 1000px; */

    /* @media (max-width: 768px) {
      margin: 150px auto 100px;
      padding: 0 1rem 1rem;
    } */
  `;
  const Main = styled.main`
    /* max-width: 1000px; */
  `;

  if (location.pathname === rootPath) {
    header = (
      <h1
        style={{
          marginBottom: "2.7rem",
          marginTop: 0,
          display: "none",
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          {title}
        </Link>
      </h1>
    );
  } else {
    header = (
      <h1
        style={{
          marginTop: 0,
        }}
      >
        {title}
      </h1>
    );
  }
  return (
    <LayoutContainer>
      <NavigationSimple />
      <header>{header}</header>
      <Main>{children}</Main>
      <FooterSimple />
    </LayoutContainer>
  );
};

export default LayoutSimple;
